import Vue from "vue";
import store from "./store";
import App from "./App.vue";

// Vue-Axios
import Axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VueAxios, Axios);

//console.log("Env Mode " + process.env.NODE_ENV);

Axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT;
Axios.defaults.headers.common["Authorization"] = "AUTH TOKEN";
Axios.defaults.headers.post["Content-Type"] = "application/json";

//console.log("Setting of Axios.baseURL " + Axios.defaults.baseURL );

// VeeValidate
import VeeValidate from "vee-validate";
const VueValidationEs = require("vee-validate/dist/locale/es");

Vue.use(VeeValidate, {
  aria: true,
  dictionary: {
    es: VueValidationEs
  },
  classes: true,
  classNames: {
    valid: "is-valid",
    invalid: "is-invalid"
  },
  //events: "change|blur",
  locale: "es"
});

// BootstrapVue Dependency
import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

// VueToastr
import VueToastr from "@deveodk/vue-toastr";
// You need a specific loader for CSS files like https://github.com/webpack/css-loader
// If you would like custom styling of the toastr the css file can be replaced
import "@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css";
Vue.use(VueToastr, {
  defaultType: "info",
  defaultTimeout: 5000
});

// A Vue.js plugin for manipulating cookies
var VueCookie = require("vue-cookie");
// Tell Vue to use the plugin
Vue.use(VueCookie);

Vue.config.productionTip = false;

new Vue({
  store,
  render: h => h(App)
}).$mount("#app");
